//------------------------------------------------------------------
// Some handy maths
//------------------------------------------------------------------

export const filter = (current: number, previous: number, lag: number) => (lag * current + ((1.0 - lag) * previous));
export const map_range = (value: number, l1: number, h1: number, l2: number, h2: number) => ( l2 + (h2 - l2) * (value - l1) / (h1 - l1) );
export const sigmoid = (value: number) => ( 1.0 / (1.0 + Math.pow(Math.E, -value)) );
export const algra = (value: number) => ( value / ( 1.0 + Math.sqrt(value * value)) );

export const easeInOutQuad = (value: number) => (value < 0.5 ? 2.0 * value * value : -1.0 + (4.0 - 2.0 * value) * value) ;
